<form (ngSubmit)="onConfirm()" class="space-y-6 p-6" aria-label="Two-factor authentication form">
  <div class="text-center">
    <!-- RF-QA-196: stable ids so the dialog chrome can reference this title
         (aria-labelledby) and the explanatory copy (aria-describedby). -->
    <h2 id="mfaStepUpTitle" class="mb-1 text-h2 font-semibold text-bb-text-primary">{{ data.title }}</h2>
    @if (data.context) {
      <!-- RF-QA-196: say WHAT is being protected (e.g. "Symbol mapping data"). -->
      <p id="mfaStepUpContext" class="mb-1 text-sm font-medium text-bb-text-primary">Verifying access to {{ data.context }}.</p>
    }
    <p id="mfaStepUpMessage" class="text-sm text-bb-text-secondary">{{ data.message }}</p>
  </div>

  <div class="form__group text-left">
    <label for="mfaStepUpCode" class="mb-1 block text-sm text-bb-text-secondary">Verification code</label>
    <input
      #codeInput
      id="mfaStepUpCode"
      name="mfaStepUpCode"
      type="text"
      [ngModel]="code()"
      (ngModelChange)="code.set($event)"
      inputmode="numeric"
      autocomplete="one-time-code"
      maxlength="8"
      required
      class="block w-full rounded-md border border-bb-border bg-bb-bg-secondary px-3 py-2.5 text-center text-lg font-mono tracking-widest text-bb-text-primary focus:border-bb-accent-blue focus:outline-none focus:ring-2 focus:ring-bb-accent-blue/20"
      placeholder="000000"
      aria-describedby="mfaStepUpCode-help" />
    <span id="mfaStepUpCode-help" class="sr-only">Enter the 6-digit code from your authenticator app, or an 8-character backup code</span>
  </div>

  <button
    type="submit"
    [disabled]="code().trim().length === 0"
    class="w-full rounded-md bg-bb-accent-blue px-4 py-3 text-sm font-semibold text-white transition-all duration-200 hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-bb-accent-blue/50 focus-visible:ring-offset-2 focus-visible:ring-offset-bb-bg-primary disabled:pointer-events-none disabled:opacity-50">
    Verify
  </button>

  <button
    type="button"
    (click)="onCancel()"
    class="w-full rounded-md border border-bb-border bg-bb-bg-secondary px-4 py-2.5 text-sm font-medium text-bb-text-primary transition-all duration-200 hover:bg-bb-bg-tertiary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-bb-accent-blue/50"
    aria-label="Cancel two-factor verification">
    Cancel
  </button>
</form>
